export const getTimeDifferenceInDays = (startDate: Date, endDate: Date): number => {
  return getTimeDifferenceInMilliseconds(startDate, endDate) / (1000 * 3600 * 24);
};

export const getTimeDifferenceInMilliseconds = (startDate: Date, endDate: Date): number => {
  return endDate.getTime() - startDate.getTime();
};
